module.exports = __webpack_public_path__ + "static/media/putin.9191c4d5.png";